import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur-sm border-b border-stone" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-60">
        <a href="#" aria-label="Birdie Bag" className="flex items-center gap-3" data-id="element-61">
          <img src="https://cdn.magicpatterns.com/uploads/4sDEekiyXVshgNeog3yRkY/Adobe_Express_-_file.png" alt="Birdie Bag" className="h-9 w-auto object-contain" data-id="element-62" />
          <span className="font-display text-2xl font-bold tracking-tight text-charcoal" data-id="element-63">
            Birdie Bag
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-charcoal" data-id="element-64">
          <a href="#mission" className="hover:text-green transition-colors" data-id="element-65">
            Mission
          </a>
          <a href="#product" className="hover:text-green transition-colors" data-id="element-66">
            Product
          </a>
          <a href="#faq" className="hover:text-green transition-colors" data-id="element-67">
            FAQ
          </a>
          <a href="#contact" className="hover:text-green transition-colors" data-id="element-68">
            Contact
          </a>
        </nav>
      </div>
    </header>;
}